<template>
    <div>
<!--        Chat with-->
<!--        <strong>{{ $_.get(activity, "payload.fullname") }} </strong>-->
<!--        assigned to-->
<!--        <strong>{{ $_.get(activity, "payload.joinedUserName") }} </strong>-->
<!--        by System-->
        <span v-html="$t('notification.chatAssigned', {visitor: $_.get(activity, 'payload.fullname'), agent: $_.get(activity, 'payload.joinedUserName') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "ChatAssigned",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        getActorName() {
            if (this.activity.actor === "user") {
                return this.$_.get(this.activity, "actorUser.name");
            } else if (this.activity.actor === "visitor") {
                return this.$_.get(this.activity, "refVisitor.fullname");
            } else if (this.activity.actor === "chatbot") {
                return "Chatbot";
            } else if (this.activity.actor === "system") {
                return "System";
            }
        },
    },
});
</script>

<style scoped lang="scss"></style>
